import { space } from "@octopusdeploy/design-system-tokens";
import { useMemo } from "react";
export function useStickyPageHeaderHeight() {
    return useMemo(() => {
        //get the header dom node so we can retrieve its height.
        const stickyHeaderRef = document.querySelector("[class*=\"headerSecondaryStickiedStyle\"]");
        //default to 92 px
        const heightInPx = stickyHeaderRef?.getBoundingClientRect()?.height || 92;
        //the extra 16px is just to clear the drop shadow
        return `calc(${heightInPx}px + ${space[16]})`;
    }, []);
}
